const isLocal = window.location.hostname === "localhost";

// qa-api serves or proxies every route this app calls, and the engine serves none of them.
const envDomain = import.meta.env.VITE_QA_API_DOMAIN as string | undefined;
export const QA_API_DOMAIN = envDomain ?? (isLocal ? "http://localhost:8081" : "https://qa-api.internal.jigsaw.codes");

import { supabase } from "@/integrations/supabase/client";

export async function fetchWithSupabaseAuth(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === "string" ? input : input.toString();
  const headers = init?.headers ? new Headers(init.headers) : new Headers();

  if (url.startsWith(QA_API_DOMAIN)) {
    const session = await supabase.auth.getSession();
    const accessToken = session.data.session?.access_token;
    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }
  }

  return fetch(input, { ...init, headers });
}

export class HttpStatusError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "HttpStatusError";
    this.status = status;
  }
}

/** As `fetchWithSupabaseAuth`, but unwraps the JSON body and rethrows the API's `error` field. */
export async function fetchJsonWithSupabaseAuth<T>(input: RequestInfo | URL, init?: RequestInit): Promise<T> {
  const res = await fetchWithSupabaseAuth(input, init);
  if (res.ok) return res.json() as Promise<T>;

  const errorBody = (await res.json().catch(() => ({}))) as { error?: string };
  throw new HttpStatusError(res.status, errorBody.error ?? `Request failed (${res.status}).`);
}
